const CURRENT_MEMBER_KEY_BASE = 'current_member';
export const CurrentMemberKeyFactory = {
    byWorkspace: (workspaceId) => [
        CURRENT_MEMBER_KEY_BASE,
        workspaceId,
    ],
};
